import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Teaching from 'components/BKantarciTeaching/Teaching';
import { useEffect } from "react";

function KanatrciTeaching() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Teaching/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Teaching/>
        <Footer />
      </>
    )}
    </>
  );
}

export default KanatrciTeaching;
